<template>
  <div class="activity-apply">
    <!-- 活动信息 -->
    <div class="apply-info">
      <van-cell-group>
        <van-field
          v-model="promotionData.name"
          label="套餐名称"
          placeholder="填写活动名称"
        />
        <van-field
          type="number"
          v-model="promotionData.termOfValidity"
          label="套餐期限"
          placeholder="填写套餐期限天数"
        >
          <template #extra>
            <span>天</span>
          </template>
        </van-field>
        <van-field
          class="activity-rules"
          v-model="promotionData.rule"
          rows="5"
          autosize
          label=""
          type="textarea"
          placeholder="请填写套餐规则等信息"
          maxlength="500"
        />
      </van-cell-group>
    </div>
    <!-- 套餐信息 -->
    <div class="combo-info">
      <van-cell-group>
        <van-field
          right-icon="arrow"
          readonly
          clickable
          name="picker"
          value=""
          label="从默认设置里选择"
          @click="activityItemPicker = true"
        />
        <van-row class="combo-item-title">
          <van-col span="5">项目</van-col>
          <van-col span="5">单价</van-col>
          <van-col span="5">数量</van-col>
          <van-col span="5">单位</van-col>
          <van-col span="4">操作</van-col>
        </van-row>
        <van-row
          class="combo-item"
          v-for="(item, index) in serviceItems"
          :key="index"
        >
          <van-col span="5">
            <van-field v-model="item.itemName" placeholder="项目" />
          </van-col>
          <van-col span="5">
            <van-field
              type="number"
              v-model="item.unitPrice"
              placeholder="单价"
            />
          </van-col>
          <van-col span="5">
            <van-field
              maxlength="2"
              type="number"
              v-model="item.quantity"
              placeholder="数量"
            />
          </van-col>
          <van-col span="5">
            <van-field v-model="item.unit" placeholder="单位" />
          </van-col>
          <van-col span="4" class="clear-item">
            <van-icon name="clear" @click="handleClear(index)" />
          </van-col>
        </van-row>
        <van-button type="info" class="add-item" @click="handleAddComboItem">
          增加项目
        </van-button>
      </van-cell-group>
    </div>
    <!-- 主流程按钮 -->
    <div class="process-btn">
      <van-button type="primary" @click="handleIssue" :loading="subStatus">
        申请发布
      </van-button>
    </div>
    <!-- 活动项选择 -->
    <van-popup v-model="activityItemPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="defaultItem"
        @confirm="handleActivityItem"
        @cancel="activityItemPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { addMembersPackage, membersPackageDetail } from "@/api/combo";
import { serviceItem } from "@/api/activity";
import { Dialog } from "vant";
export default {
  data() {
    return {
      activityItemPicker: false,
      promotionData: {
        name: "",
        rule: "",
        serviceItems: [],
        termOfValidity: ""
      },
      serviceItems: [],
      defaultItem: [],
      subStatus: false
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.handleDetail();
    }
    this.handleServiceItem();
  },
  methods: {
    // 活动项目选择
    handleActivityItem(value) {
      this.activityItemPicker = false;
      this.serviceItems.push({
        itemName: value.text,
        unitPrice: value.unitPrice,
        quantity: value.quantity,
        unit: value.unit
      });
    },
    // 默认套餐项目
    handleServiceItem() {
      serviceItem().then(res => {
        // console.log("默认套餐项目:", res);
        res.forEach(val => {
          val.text = val.itemName;
          val.unitPrice = val.unitPrice / 100;
        });
        this.defaultItem = res;
      });
    },
    // 增加套餐项目
    handleAddComboItem() {
      let itemInfo = {
        itemName: "",
        unitPrice: "",
        quantity: "",
        unit: ""
      };
      this.serviceItems.push(itemInfo);
    },
    // 套餐详情
    handleDetail() {
      membersPackageDetail(this.$route.query.id).then(res => {
        // console.log("套餐详情 :>> ", res);
        this.promotionData = res;
        this.serviceItems = this.promotionData.serviceItems;
      });
    },
    // 清除项目
    handleClear(index) {
      // console.log(index);
      this.serviceItems.splice(index, 1);
    },
    // 申请发布
    handleIssue() {
      this.subStatus = true;
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      this.promotionData.serviceItems = this.serviceItems;
      addMembersPackage(this.promotionData).then(res => {
        this.subStatus = false;
        // console.log("申请发布:", res);
        if (res.code === 0) {
          Dialog.alert({
            title: "提示",
            message: "发布成功,请在会员套餐中查看"
          }).then(() => {
            // this.$router.push("/activity/membersPackageList");
            this.$router.push("/");
          });
        }
      });
    },
    // 表单校验
    handleFormVerify() {
      let serviceItemsRules = false;
      let serviceItemsUnitPrice = false;
      let serviceItemsQuantity = false;
      this.serviceItems.forEach(val => {
        for (const key in val) {
          if (val[key].trim() === "") {
            serviceItemsRules = true;
            return false;
          }
        }
        if (val.unitPrice <= 0) {
          serviceItemsUnitPrice = true;
          return false;
        }
        if (val.quantity <= 0) {
          serviceItemsQuantity = true;
          return false;
        }
      });
      if (!/[\u4e00-\u9fa5]/gm.test(this.promotionData.name.trim())) {
        this.$toast("活动名称请输入中文");
        return false;
      }
      if (this.promotionData.rule.trim() === "") {
        this.$toast("请填写活动规则");
        return false;
      }
      if (this.serviceItems.length === 0) {
        this.$toast("请填写活动项目");
        return false;
      }
      if (serviceItemsRules) {
        this.$toast("活动项目内容不得为空");
        return false;
      }
      if (serviceItemsUnitPrice) {
        this.$toast("项目价格不得小于或等于0");
        return false;
      }
      if (serviceItemsQuantity) {
        this.$toast("项目数量不得小于或等于0");
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-apply {
  .apply-info {
    border-bottom: 5px solid #eaeaea;
  }

  .combo-info {
    border-bottom: 5px solid #eaeaea;

    .combo-item-title {
      padding-top: 16px;
      padding-left: 10px;
    }

    .combo-item {
      padding-top: 10px;
      padding-left: 10px;

      .clear-item {
        .van-icon {
          top: 4px;
          color: red;
        }
      }
    }

    .add-item {
      height: 30px;
      margin-top: 16px;
      margin-bottom: 16px;
      line-height: 30px;
    }
  }

  .process-btn {
    display: flex;
    justify-content: space-around;
    margin-top: 16px;
  }
}
</style>
<style lang="scss">
.activity-apply {
  .apply-info {
    .uploader {
      padding: 10px 16px;
      padding-left: 30px;
      text-align: left;
    }

    .activity-rules {
      padding-left: 30px;

      .van-field__value {
        border: 1px solid #ebedf0;
      }

      .van-field__control {
        padding: 10px;
      }
    }
  }

  .combo-info {
    .van-cell {
      padding-left: 30px;
    }

    .van-field__label {
      width: 130px;
      text-align: left;
    }

    .combo-item {
      .van-cell {
        padding: 0;
      }

      .van-field__control {
        text-align: center;
      }
    }
  }

  .active-setting {
    .van-cell {
      padding-left: 30px;
    }

    .van-field__label {
      width: 130px;
      text-align: left;
    }
  }
}
</style>
